import React from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "../../../store/hooks";
import { Label, Row } from "./RecommendationPanel";

export const Weighting = () => {
  const { t } = useTranslation();
  const loadRecommendationStatus = useSelector(
    (s) => s.recommendationPanel.loadRecommendationStatus,
  );
  const recommendation = useSelector(
    (s) => s.recommendationPanel.recommendation,
  );
  const isLoading = loadRecommendationStatus === "loading";

  let render;
  if (isLoading) render = <Skeleton width={150} />;
  else render = recommendation?.weighting;

  return (
    <Row>
      <Label>{t("ram.recommendationForm.weighting.label")}:</Label>
      {render}
    </Row>
  );
};
